let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gd5li")).then(() => parcelRequire('hPTxc'));